var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaIcPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89511 14.0657L8.64876 11.017C8.25295 10.0523 7.42082 10.7961 6.78568 10.8808C5.90017 10.9986 5.08829 8.89804 4.82319 8.25001C4.82255 8.24513 4.82255 8.24017 4.82319 8.23528C4.82134 8.23055 4.82134 8.22529 4.82319 8.22056C4.779 8.1101 4.71273 7.95546 4.63909 7.77688C4.29483 6.90794 3.78487 5.41121 4.37583 4.96754C4.89131 4.58277 6.00695 4.53306 5.61114 3.56471L4.36663 0.516035C4.28184 0.312121 4.11995 0.149943 3.91619 0.0647839C3.71243 -0.020375 3.48329 -0.0216238 3.27861 0.0613119C2.57167 0.348505 1.75795 0.571269 1.13386 1.02047C-0.0609403 1.87653 -0.0646192 3.54077 0.0439989 4.84972C0.182073 6.5066 0.682816 8.13219 1.30507 9.65837C1.30446 9.66264 1.30446 9.66698 1.30507 9.67126V9.68414C1.52967 10.2364 1.77636 10.7887 2.04146 11.3189C2.51471 12.2735 3.09264 13.1726 3.76462 13.9994C4.60227 15.0101 5.7713 16.1957 7.22384 15.9729C7.98233 15.8533 8.72056 15.4427 9.43302 15.1537C9.63827 15.0703 9.80212 14.909 9.88872 14.7051C9.97532 14.5012 9.97762 14.2713 9.89511 14.0657Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaIcPhone);
export default __webpack_public_path__ + "static/media/pa_ic_phone.609e189b40377cd5699ef3bf850f11f3.svg";
export { ForwardRef as ReactComponent };